<div class="flex-row-start-center fxFlex">
  <div class="fxFlex-20p col-invoice">{{ invoice.invoice.invoice_number }}</div>
  <div class="fxFlex-20p col-static">
    {{ invoice.invoice.event.stats.total }}
  </div>
  <div class="fxFlex-20p col-static">{{ invoice.invoice.paid_amount }}</div>
  <div class="fxFlex-20p col-balance">
    {{ invoice.invoice.event.balance_label }}
  </div>
  <div class="fxFlex-20p col-cashing" [formGroup]="form">
    <mat-form-field class="invoice-input fxFlexFill">
      <input
        matInput
        placeholder=""
        type="text"
        step=".01"
        pattern="^[0-9]+([.,][0-9]{1,2})?"
        formControlName="amount"
        (ngModelChange)="onAmountChange($event)"
        (blur)="onAmountBlur()"
        [ngModel]="amountText"
        class=""
      />
    </mat-form-field>
  </div>
</div>
